import styled from 'styled-components';
import { ProductName as ProductNameStyles } from '../../styles';

export const StockStatus = styled.div`
  color: ${p => p.theme.text.quaternary};
  font-size: 0.8rem;
  margin: 0 0.2em;
`;

export const ProductName = ProductNameStyles;
